import { LegacyCard, ResourceList, ResourceItem, Text, Page } from '@shopify/polaris'

import { useAuth } from '@/context'
import ReviewBanner from '@/components/ReviewBanner'
import Footer from '@/components/Footer'
import Skeleton from '@/components/Skeleton'

export async function getServerSideProps(context: any) {
  const shop = context.query.shop
  if (!shop) {
    return {
      props: {},
    }
  }

  context.res.setHeader(
    'Content-Security-Policy',
    `frame-ancestors https://${shop} https://admin.shopify.com;`
  )

  return {
    props: {},
  }
}

export default function ResourceListExample() {
  const { currentShop } = useAuth()

  const fulfillmentOptions = [
    {
      fulfillmentOption: 'Mark as Fulfill',
      description: 'Bulk mark as fulfill without tracking number',
      url: `/fulfillment/mark-fulfillment${window.location.search}`,
    },
    {
      fulfillmentOption: 'Create Fulfillment',
      description: 'Bulk create fulfillment with tracking number & Sync Tracking to Paypal',
      url: `/fulfillment/create-fulfillment${window.location.search}`,
    },
    {
      fulfillmentOption: 'Replace Tracking Number',
      description:
        'Bulk replace tracking number, tracking url, tracking company & Sync Tracking to Paypal',
      url: `/fulfillment/update-fulfillment${window.location.search}`,
    },
    {
      fulfillmentOption: 'Paypal Tracking Verification (FREE)',
      description: 'Bulk check if tracking is synced to Paypal',
      url: `/fulfillment/paypal-tracking-verification${window.location.search}`,
    },
  ]

  return (
    <>
      {!currentShop && <Skeleton />}

      {currentShop && (
        <>
          <ReviewBanner />

          <Page fullWidth title="Choose your option" subtitle="Pick your most suitable option">
            <LegacyCard>
              <ResourceList
                resourceName={{ singular: 'customer', plural: 'customers' }}
                items={fulfillmentOptions}
                renderItem={(item) => {
                  const { fulfillmentOption, url, description } = item

                  return (
                    <ResourceItem
                      id={fulfillmentOption}
                      url={url}
                      accessibilityLabel={`View details for ${fulfillmentOption}`}
                    >
                      <Text variant="bodyMd" fontWeight="bold" as="h3">
                        {fulfillmentOption}
                      </Text>
                      <div>{description}</div>
                    </ResourceItem>
                  )
                }}
              />
            </LegacyCard>
          </Page>

          <Footer />
        </>
      )}
    </>
  )
}
